import React from "react";
import "./styles.scss";
import { FormCheck, FormCheckUpdated } from "..";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`check-item-wrapper ${data.type} ${
          data.isActive ? "active-me" : ""
        }`}
        onClick={onClick}
      >
        <div className={"ciw__checkName"}> {data.checkName}</div>
        <FormCheck
          data={{ iconName: "check", isSelect: data.isActive ? true : false }}
        />
      </div>
    </>
  );

  return <>{inputElement}</>;
};

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
